import { convertToRaw, EditorState, ContentState } from 'draft-js';
import parse from 'html-react-parser';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

export const convertEditorToHtml = (d) => parse(
  draftToHtml(convertToRaw(d.getCurrentContent())),
);

export const convertStringToHtml = (d) => parse(d);

export const convertEditorToString = (d) => {
  if (d) {
    return draftToHtml(convertToRaw(d.getCurrentContent()));
  }
  return '';
};

export const convertStringToEditor = (d) => {
  if (d) {
    const contentBlock = htmlToDraft(d);
    let editorState;
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      editorState = EditorState.createWithContent(contentState);
    }
    return editorState;
  }
  return '';
};
